import { useState } from 'react';
import { Champ, styleChamp } from './champs';
import { BoutonsFormulaire } from './FormulaireTache';
import { heureDe, jourDe } from '../format';
import type { ModificationRappel } from '@colette/shared';
import type { Rappel } from '../../api/types';

/**
 * Modifier un rappel : son message, son jour, son heure. N'envoie que ce qui change.
 *
 * Deplacer un rappel deja parti le remet en etat de sonner (le serveur remet notifiedAt a
 * zero) : sans cela, reporter un rappel serait silencieusement inutile.
 */
export function FormulaireRappel({
  rappel,
  fuseau,
  occupe,
  onEnregistrer,
  onAnnuler,
}: {
  rappel: Pick<Rappel, 'message' | 'remindAt'>;
  fuseau: string;
  occupe: boolean;
  onEnregistrer: (modification: ModificationRappel) => void;
  onAnnuler: () => void;
}) {
  const jourInitial = jourDe(rappel.remindAt, fuseau);
  const heureInitiale = heureDe(rappel.remindAt, fuseau);
  const [message, setMessage] = useState(rappel.message);
  const [jour, setJour] = useState(jourInitial);
  const [heure, setHeure] = useState(heureInitiale);

  const enregistrer = () => {
    if (occupe) return;
    const modification: ModificationRappel = {};
    if (message.trim() !== rappel.message) modification.message = message.trim();
    if (jour !== jourInitial) modification.date = jour;
    if (heure !== heureInitiale) modification.time = heure;
    if (Object.keys(modification).length === 0) {
      onAnnuler();
      return;
    }
    onEnregistrer(modification);
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        enregistrer();
      }}
      style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%' }}
    >
      <Champ libelle="Message">
        <input
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          aria-label="Message du rappel"
          style={styleChamp}
        />
      </Champ>
      <div style={{ display: 'flex', gap: 8 }}>
        <div style={{ flex: 1.4, minWidth: 0 }}>
          <Champ libelle="Jour">
            <input
              type="date"
              value={jour}
              onChange={(e) => setJour(e.target.value)}
              aria-label="Jour du rappel"
              style={styleChamp}
            />
          </Champ>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Champ libelle="Heure">
            <input
              type="time"
              value={heure}
              onChange={(e) => setHeure(e.target.value)}
              aria-label="Heure du rappel"
              style={styleChamp}
            />
          </Champ>
        </div>
      </div>
      <BoutonsFormulaire occupe={occupe} onAnnuler={onAnnuler} ariaAnnuler="Annuler la modification" />
    </form>
  );
}
